import paths from "../../api/paths.api";

export const userNavItems = [
  { label: "Projects", type: "link", link: paths.myProjects },
  { label: "Material Records", type: "link", link: paths.myMaterialRecords },
  { label: "AMS", type: "link", link: paths.ams },
  { label: "Software", type: "link", link: paths.softwares },
  // { label: "Onboarding", type: "link", link: paths.onboarding },
  // {
  //   label: "Resource Management",
  //   type: "mega_menu",
  //   items: [
  //     {
  //       header: "Project Management",
  //       subItems: [
  //         { label: "Tasks", link: paths.mytasks },
  //         { label: "RACI", link: paths.mytasks },
  //       ],
  //     },
  //     {
  //       header: "Materials Management",
  //       subItems: [
  //         { label: "Material Records", link: paths.mytasks },
  //         { label: "Material Database", link: paths.mytasks },
  //       ],
  //     },
  //   ],
  // },
];
